import * as React from 'react';
import { SyntaxDisplay } from '../SyntaxDisplay/index';
import { SectionContainer } from '../../../SectionContainer';
import { CallbacksTableContainer, isCallback } from './CallbacksTableDisplay';
import { MixedInFrom } from '../../../LibraryView/AdditionalInfo/MixedInFrom';
import style from './JSOperationView.scss';
import { JSParamTable } from './JSParamTable';
import { sectionPrefix } from '../../../NavigationMenu/utils';

export const JSOperationView = ({
  operation,
  prefix,
  artifactId,
  JSLayoutType = false,
}) => {
  const path = sectionPrefix(prefix, operation.urlFormat);
  const shouldPresentRelatedContent = operation.docs?.links?.length > 0;
  const hasCallbacks = operation.params.some(isCallback);
  return (
    <React.Fragment key={operation.name}>
      <SectionContainer className={style.syntaxContainer}>
        <SyntaxDisplay
          operation={operation}
          artifactId={artifactId}
          JSLayoutType={JSLayoutType}
        />
      </SectionContainer>

      <SectionContainer className={hasCallbacks ? style.operationParams : ''}>
        <JSParamTable
          operation={operation}
          path={path}
          prefix={prefix}
          JSLayoutType={JSLayoutType}
        />
      </SectionContainer>

      {hasCallbacks && (
        <SectionContainer className={style.callbackContainer}>
          <CallbacksTableContainer
            operation={operation}
            path={path}
            prefix={prefix}
          />
        </SectionContainer>
      )}

      {operation.mixedInFrom && (
        <div
          data-hook="inherited-from-container"
          style={{
            marginBottom: shouldPresentRelatedContent ? '24px' : 0,
          }}
        >
          <MixedInFrom
            items={[
              `${operation.mixedInFrom.memberOf}.${operation.mixedInFrom.name}`,
            ]}
          />
        </div>
      )}
    </React.Fragment>
  );
};
